import moment from "moment";
import { useCallback, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { IEsteira } from "../../interfaces/IEsteira";
import { IConta, ILancamento, IPossiveisConciliados } from "../../interfaces/IRelatorio";
import EmpresasService from "../../services/EmpresasService";
import RelatoriosService from "../../services/RelatoriosService";
import { groupBy } from "../../utils/Array";
import { normalize, similarity } from "../../utils/String";
import { Formatter } from "../relatorios/Relatorio";
import { Modal } from 'react-bootstrap-v5';

type UrlParam = {
    empresaParam: string,
    contaParam: string,
    esteiraParam: string
}

function Row({ item, withBackground, onRemove, onRemovePayment }: { item: IPossiveisConciliados, withBackground: boolean, onRemove: Function, onRemovePayment: Function }) {
    const [abrirPagamento, setAbrirPagamento] = useState<boolean>(true);

    return <>
        <tr style={{ backgroundColor: withBackground ? 'rgba(0, 183, 161, 0.05)' : 'none', fontWeight: 'bold', borderBottom: 'none' }}>
            <td><button onClick={() => setAbrirPagamento(!abrirPagamento)} className="btn btn-default">{abrirPagamento ? 'Ocultar' : 'Mostrar'}</button></td>
            <td></td>
            <td><button onClick={() => onRemove()} className="btn btn-default">Excluir</button></td>
            <td>{moment(item.provisao.dataLancamento).format('DD/MM/YYYY')}</td>
            <td>{Formatter.format(item.provisao.valorProvisaoRecolher || 0)}</td>
            <td>{item.provisao.historico}</td>
            <td>{item.provisao.tipoLancamento}</td>
        </tr>
        {abrirPagamento && (
            item.pagamento.map((item2) => (
                <tr style={{ backgroundColor: withBackground ? 'rgba(0, 183, 161, 0.05)' : 'none', fontWeight: 'bold', borderTop: 'none' }}>
                    <td></td>
                    <td></td>
                    <td><button onClick={() => onRemovePayment(item2.id)} className="btn btn-default">Excluir</button></td>
                    <td>{moment(item2.dataLancamento).format('DD/MM/YYYY')}</td>
                    <td>{Formatter.format(item2.valorProvisaoRecolher || 0)}</td>
                    <td>{item2.historico}</td>
                    <td>{item2.tipoLancamento}</td>
                </tr>
            ))
        )}
    </>
};

function ModalLancamentos({ toggleModal, show, lancamentos }: { toggleModal: () => void, show: boolean, lancamentos: ILancamento[] }) {

    return (
        <Modal size='lg' centered={true} show={show} onHide={toggleModal}>
            <div className="modal-content" style={{ backgroundColor: '#F4F5F7' }}>
                <div className="modal-header">
                    <h5 className="modal-title titulo-modal" style={{ textTransform: 'uppercase' }}>Lançamentos</h5>
                    <div className="btn btn-icon btn-sm btn-active-light-primary ms-2">
                        <i onClick={toggleModal} className="fas fa-times" style={{ color: '#5E6397' }}></i>
                    </div>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className="col-md-12">
                            <table className="table table-striped">
                                <thead>
                                    <tr>
                                        <th scope="col">Data</th>
                                        <th scope="col">Histórico</th>
                                        <th scope="col">Tipo</th>
                                        <th scope="col">Valor</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {lancamentos.map((item) => (
                                        <tr>
                                            <td>{moment(item.dataLancamento).format('DD/MM/YYYY')}</td>
                                            <td>{item.historico}</td>
                                            <td>{item.tipoLancamento}</td>
                                            <td>{Formatter.format(item.valorProvisaoRecolher || 0)}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    )
}

function ConciliacaoInteligenteGrupo() {

    const [regra] = useState<any>({
        1: 'VALOR',
        2: 'HISTÓRICO',
        3: 'NOTA'
    });

    const [regraSelecionada, setRegraSelecionada] = useState<number>(0);
    const [carregado, setCarregado] = useState<boolean>(false);
    const [carregando, setCarregando] = useState<boolean>(false);
    const [carregandoPossiveisConciliacoes, setCarregandoPossiveisConciliacoes] = useState<boolean>(false);
    const [esteira, setEsteira] = useState<IEsteira>();
    const [conta, setConta] = useState<IConta>();
    const [lancamentosOriginais, setLancamentosOriginais] = useState<ILancamento[]>([]);
    const [possiveisConciliacoes, setPossiveisConciliacoes] = useState<IPossiveisConciliados[]>([]);
    const [showLancamentos, setShowLancamentos] = useState<boolean>(false);
    const [historicoExcecao, setHistoricoExcecao] = useState<string>('');
    const { empresaParam, esteiraParam, contaParam } = useParams<UrlParam>();
    const history = useHistory();

    const onConciliar = useCallback(async () => {
        if (possiveisConciliacoes.length > 0) {
            setCarregando(true);
            const final: any[] = [];

            possiveisConciliacoes.forEach(item => {
                const ids: number[] = [item.provisao.id || 0];
                item.pagamento.forEach(f => {
                    ids.push(f.id || 0)
                })

                final.push({ ids });
            });

            await EmpresasService.conciliarMuitosLancamentos(final);

            Swal.fire({
                text: 'Conciliação feita com sucesso',
                timer: 3000,
                icon: 'success',
                showConfirmButton: false
            });

            setCarregando(false);


            setLancamentosOriginais((old) => {
                let copy = [...old];

                const idsToRemove: number[] = [];
                possiveisConciliacoes.forEach(item => {
                    idsToRemove.push(item.provisao.id || 0);

                    item.pagamento.forEach(f => {
                        idsToRemove.push(f.id || 0)
                    });
                });

                return copy.filter(f => !idsToRemove.includes(f.id || 0));
            });

            setPossiveisConciliacoes([]);
        }
    }, [possiveisConciliacoes]);

    const onClickProcessar = useCallback(() => {
        if (regraSelecionada <= 0) {
            Swal.fire({
                text: 'Por favor selecione uma opção',
                timer: 3000,
                icon: 'error',
                showConfirmButton: false
            });

            return;
        }

        setPossiveisConciliacoes([]);
        setCarregandoPossiveisConciliacoes(true);
        const provisao = conta?.ativoContabil ? "D" : "C";
        const pagamento = conta?.ativoContabil ? "C" : "D";

        const lancamentosProvisao = lancamentosOriginais.filter((item) => item.tipoLancamento === provisao);

        console.log('lancamentos no valor de 18770', lancamentosProvisao.filter(f => f.valorProvisaoRecolher === 18770))
        const lancamentosPagamento = lancamentosOriginais.filter((item) => item.tipoLancamento === pagamento);

        const possiveisConciliacoesAux: IPossiveisConciliados[] = [];

        lancamentosProvisao.forEach((item) => {
            if (!item.conciliado) {
                const pagamentosNaDataValida = lancamentosPagamento.filter((p) => !p.conciliado && p.dataLancamento && item.dataLancamento && p.dataLancamento >= item.dataLancamento);
                if (pagamentosNaDataValida.length > 0) {
                    switch (regraSelecionada) {
                        case 1:
                            const pagamentosNoMesmoValor = pagamentosNaDataValida.filter((p) => p.valorProvisaoRecolher === item.valorProvisaoRecolher);
                            if (pagamentosNoMesmoValor.length > 0) {
                                let conciliou = false;
                                pagamentosNoMesmoValor.forEach(fp => {
                                    if (!conciliou) {
                                        if (!possiveisConciliacoesAux.find(f => f.pagamento.find(fi => fi.id === fp.id))) {
                                            conciliou = true;
                                            possiveisConciliacoesAux.push({ pagamento: [fp], provisao: item, conciliado: true })
                                        }
                                    }
                                });
                            }

                            break;
                        case 2:
                            const pagamentosNoHistorico = pagamentosNaDataValida.filter((p) => similarity(normalize(p.historico, historicoExcecao), normalize(item.historico, historicoExcecao)) >= 0.50);
                            if (pagamentosNoHistorico.length > 0) {
                                const validate: ILancamento[] = [];
                                pagamentosNoHistorico.forEach(i => {
                                    if (!possiveisConciliacoesAux.find(f => f.pagamento.find(fi => fi.id === i.id))) {
                                        validate.push(i);
                                    }
                                })

                                if (validate.length > 0) {
                                    possiveisConciliacoesAux.push({ pagamento: validate, provisao: item, conciliado: true })
                                }
                            }
                            break;
                        case 3:
                            const number = item.historico.replace(/\D/g, "");
                            if (number) {
                                const pagamentosMesmaChave = pagamentosNaDataValida.filter((p) => p.historico.replace(/\D/g, "") === number);
                                const pagamentosChaves = pagamentosMesmaChave.filter((p) => p.historico.replace(/\D/g, "") === number);
                                if (pagamentosChaves.length > 0) {
                                    const validate: ILancamento[] = [];
                                    pagamentosChaves.forEach(i => {
                                        if (!possiveisConciliacoesAux.find(f => f.pagamento.find(fi => fi.id === i.id))) {
                                            validate.push(i);
                                        }
                                    })

                                    if (validate.length > 0) {
                                        possiveisConciliacoesAux.push({ pagamento: validate, provisao: item, conciliado: true })
                                    }
                                }
                            }
                            break;
                        default:
                            break;
                    }
                }
            }
        });

        setPossiveisConciliacoes(possiveisConciliacoesAux);
        setCarregandoPossiveisConciliacoes(false);

    }, [regraSelecionada, conta, lancamentosOriginais, historicoExcecao]);

    useEffect(() => {
        if (!carregando && !carregado) {
            setCarregando(true);
            EmpresasService.obterEsteiras(parseInt(empresaParam) || 0).then((resp) => {
                const esteira = resp?.find(f => f.id === parseInt(esteiraParam));
                setEsteira(esteira);
                EmpresasService.obterConta(parseInt(esteiraParam) || 0, contaParam).then((resp) => {
                    setConta(resp);
                    EmpresasService.obeterLancamentosPendentesEsteira(parseInt(esteiraParam) || 0, contaParam, '').then((val) => {
                        if (resp && val.length > 0) {

                            const statusValido = (s: string) => s === "PENDENTE" || s === "RECOLHIDOMAIOR" || s === "RECOLHIDOMENOR";
                            let cred = val.filter(f => f.tipoLancamento === "C" && statusValido(f.status));
                            let deb = val.filter(f => f.tipoLancamento === "D" && statusValido(f.status));

                            const result = val.filter(f => f.status !== "PENDENTE" && f.chaveVinculo);
                            if (result.length > 0) {
                                const grouped = groupBy(result, 'chaveVinculo');

                                if (grouped) {
                                    const keys = Object.keys(grouped);
                                    keys.forEach(key => {
                                        const creditosChave = grouped[key].filter((f: ILancamento) => f.tipoLancamento === "C") as ILancamento[];
                                        const debitosChave = grouped[key].filter((f: ILancamento) => f.tipoLancamento === "D") as ILancamento[];

                                        if (creditosChave.length > 0 && debitosChave.length > 0) {
                                            const somaCreditos = creditosChave.map((item) => item.valorProvisaoRecolher || 0).reduce((a, b) => a + b, 0);
                                            const somaDebitos = debitosChave.map((item) => item.valorProvisaoRecolher || 0).reduce((a, b) => a + b, 0);

                                            if (resp.ativoContabil) {
                                                if (somaDebitos > somaCreditos) {
                                                    deb.push({
                                                        ...debitosChave[0],
                                                        valorProvisaoRecolher: Math.round(Math.abs(somaCreditos - somaDebitos) * 100) / 100,
                                                        tipoLancamento: "D"
                                                    });
                                                } else {
                                                    cred.push({
                                                        ...debitosChave[0],
                                                        valorProvisaoRecolher: Math.round(Math.abs(somaCreditos - somaDebitos) * 100) / 100,
                                                        tipoLancamento: "C"
                                                    });
                                                }
                                            } else {
                                                if (somaDebitos > somaCreditos) {
                                                    cred.push({
                                                        ...creditosChave[0],
                                                        valorProvisaoRecolher: Math.round(Math.abs(somaCreditos - somaDebitos) * 100) / 100,
                                                        tipoLancamento: "D"
                                                    });
                                                } else {
                                                    deb.push({
                                                        ...creditosChave[0],
                                                        valorProvisaoRecolher: Math.round(Math.abs(somaCreditos - somaDebitos) * 100) / 100,
                                                        tipoLancamento: "C"
                                                    });
                                                }
                                            }
                                        }
                                    });
                                }
                            }

                            setLancamentosOriginais([...cred, ...deb]);
                            setCarregado(true);
                            setCarregando(false);
                        }
                    });
                });
            });
        }
    }, [contaParam, empresaParam, esteiraParam, carregado, carregando]);


    return <>
        {
            carregando ?
                <div className="row">
                    <div className="col-md-12">
                        <span className='indicator-progress' style={{ display: 'block' }}>
                            Estamos preparando sua conta...{' '}
                            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                        </span>
                    </div>
                </div>
                :
                <div className="row">
                    <ModalLancamentos show={showLancamentos} toggleModal={() => setShowLancamentos(false)} lancamentos={lancamentosOriginais} />
                    <div className="col-md-12">
                        <div className="row">
                            <div className="col-md-4">
                                <div className="form-group">
                                    <label>Período</label>
                                    <input type="text" value={`${esteira?.periodoInicioString} - ${esteira?.periodoFimString}`} className="form-control" />
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="form-group">
                                    <label>Conta</label>
                                    <input type="text" value={`${conta?.nome} - ${conta?.codigo}`} className="form-control" />
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="form-group">
                                    <label>Total de Lançamentos</label>
                                    <input type="text" value={lancamentosOriginais.length} className="form-control" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12 mt-5">
                        <div className="row">
                            <div className="col-md-4">
                                <div className="form-group">
                                    <label>Selecione uma opção para conciliação em grupo</label>
                                    <select value={regraSelecionada} onChange={(e) => setRegraSelecionada(parseInt(e.target.value))} disabled={carregandoPossiveisConciliacoes} className="form-control mt-2">
                                        <option value={0}>Selecione uma opção..</option>
                                        {Object.keys(regra).map((item) => (
                                            <option value={item}>{regra[item]}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            {regraSelecionada === 2 && (
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label>Histórico Exceção</label>
                                        <input className="form-control mt-2" value={historicoExcecao} onChange={(e) => setHistoricoExcecao(e.target.value)} />
                                    </div>
                                </div>
                            )}
                            <div className="col-md-2">
                                <div className="form-group mt-7">
                                    <button disabled={carregandoPossiveisConciliacoes} onClick={() => onClickProcessar()} type="button" style={{ width: '100%' }} className="btn btn-success">PROCESSAR</button>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="form-group mt-7">
                                    <button disabled={carregandoPossiveisConciliacoes} onClick={() => setShowLancamentos(true)} type="button" style={{ width: '100%' }} className="btn btn-success">VER LANÇAMENTOS</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12 mt-4">
                        {carregandoPossiveisConciliacoes ?
                            <div className="row">
                                <div className="col-md-12">
                                    <span className='indicator-progress' style={{ display: 'block' }}>
                                        Estamos preparando as possíveis conciliações por {regra[regraSelecionada].toLowerCase()}...{' '}
                                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                    </span>
                                </div>
                            </div> :
                            <div className="row">
                                {possiveisConciliacoes.length > 0 ? (
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th style={{ fontWeight: 'bold' }} className="h5">Ações</th>
                                                <th></th>
                                                <th></th>
                                                <th style={{ fontWeight: 'bold' }} className="h5" scope="col">Data do Lançamento</th>
                                                <th style={{ fontWeight: 'bold' }} className="h5" scope="col">Valor do Lançamento</th>
                                                <th style={{ fontWeight: 'bold' }} className="h5" scope="col">Histórico do Lançamento</th>
                                                <th style={{ fontWeight: 'bold' }} className="h5" scope="col">Tipo do Lançamento</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                possiveisConciliacoes.map((item, i) => (
                                                    <Row
                                                        onRemove={() => {
                                                            setPossiveisConciliacoes((old) => {
                                                                const copy = [...old];
                                                                copy.splice(i, 1);
                                                                return copy;
                                                            })
                                                        }}
                                                        onRemovePayment={(id: number) => {
                                                            setPossiveisConciliacoes((old) => {
                                                                const copy = [...old];
                                                                const payment = [...copy[i].pagamento];
                                                                const indexPayment = payment.findIndex(f => f.id === id);
                                                                if (indexPayment >= 0) {
                                                                    payment.splice(indexPayment, 1);
                                                                    copy[i].pagamento = payment;
                                                                }

                                                                if (payment.length <= 0) {
                                                                    copy.splice(i, 1);
                                                                }

                                                                return copy;
                                                            })
                                                        }}
                                                        item={item}
                                                        withBackground={i % 2 === 0}
                                                    />
                                                ))
                                            }
                                        </tbody>
                                    </table>
                                ) : (
                                    <span>Por enquanto não encontramos nenhuma possível conciliação</span>
                                )}
                                <div className="row mt-3">
                                    <div className="col-md-3 col-xs-2">
                                        <div className="form-group">
                                            <button disabled={carregandoPossiveisConciliacoes} onClick={async () => {
                                                await RelatoriosService.updateStatusConta(contaParam, parseInt(esteiraParam) || 0, "Em Conferencia");
                                                history.goBack();
                                            }} style={{ width: '100%' }} type="button" className="btn btn-success">CONCLUIR CONCILIAÇÃO</button>
                                        </div>
                                    </div>
                                    <div className="col-md-2">
                                        {possiveisConciliacoes.length > 0 && (
                                            <div className="form-group">
                                                <button disabled={carregandoPossiveisConciliacoes || possiveisConciliacoes.length === 0} onClick={() => onConciliar()} type="button" className="btn btn-success">CONCILIAR</button>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
        }
    </>
};

export default ConciliacaoInteligenteGrupo;